export const FrequencyType = {
  Month: {
    key: 1,
    value: 'month',
    showInSelect: true,
  },
  Date: {
    key: 2,
    value: 'date',
    showInSelect: true,
  },
  Day: {
    key: 3,
    value: 'day',
    showInSelect: true,
  },
  Completion: {
    key: 4,
    value: 'completion',
    showInSelect: true,
  },
  NA: {
    key: 5,
    value: 'N/A',
    showInSelect: true,
  },
};
